export const SECOND = 1000;
export const REDIRECT_DELAY_IN_SECONDS = 3;
export const MINIMUM_MEETING_DURATION = 15;